import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface Technique {
    id: string;
    kataId: string;
    technique: string;
    description: string;
    curriculumId: string | null;
    sequence: number;
    danNo: number;
}
function Kata({ selectedBelt }: { selectedBelt: number }) {
    const [items, setItems] = useState<Technique[]>([]);
    const navigate = useNavigate();

    console.log('Selected Belt:', selectedBelt);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const username = process.env.REACT_APP_API_USERNAME;
                const password = process.env.REACT_APP_API_PASSWORD;
                const token = btoa(`${username}:${password}`); // Base64 encode username and password
                const response = await axios.get<Technique[]>(`${process.env.REACT_APP_API_URL}/Kata/${selectedBelt}/Techniques`,
                    {
                        headers: {
                            Authorization: `Basic ${token}`,
                        },
                    }
                ); // Replace with your actual endpoint
                console.log(response.data); // Log the response data to see what is being returned

                const filteredItems = response.data;

                if (filteredItems.length === 0) {
                    console.warn('No items found for the selected belt color:', selectedBelt);
                }

                setItems(filteredItems);

            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        fetchData();
    }, [selectedBelt]);


    return (
        <div className="quiz-container">
            <button className="close-button" onClick={() => navigate('/')}>&times;</button>
            {selectedBelt && <h2 className="quiz-title"> {selectedBelt} Dan</h2>}
            <div className="technique-list">
                {items.map((item) => (
                    <div key={item.id} className="technique-item">
                        <h4>{item.sequence}. {item.technique}</h4>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
            {items.length === 0 && <p>No techniques available for this belt.</p>}

        </div>
    );
}

export default Kata;

function setItems(filteredItems: Technique[]) {
    throw new Error("Function not implemented.");
}
